export const StatusFilter = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "InActive" },
];
